import Badge from './badge'
import ClickOutside from './click-outside'
import Ripple from './ripple'
import Tooltip from './tooltip'

export default {
  Badge,
  ClickOutside,
  Ripple,
  Tooltip
}



// WEBPACK FOOTER //
// ./src/directives/_index.js